import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useForm } from "react-hook-form";
import { isEmpty, pick } from "lodash";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
const ProfileComp = ({ setShow }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({});

  useEffect(() => {
    if (!isEmpty(profileData)) {
      setValue("email", profileData?.email);
      setValue("firstName", profileData?.firstName);
      setValue("lastName", profileData?.lastName);
    }
  }, [profileData]);
  const onSubmit = async (request) => {
    setLoader(true);
    let obj = pick(request, ["email", "firstName", "lastName"]);
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.userProfileUpdate,
        { ...obj }
      );
      if (status === 200) {
        if (response_users.success) {
          toast.success(response_users?.message);
          setLoader(false);
          setShow("");
        } else {
          toast.error(response_users?.message);
          setLoader(false);
        }
      } else {
        toast.error(response_users?.message);
        setLoader(false);
      }
    } catch (err) {
      setLoader(false);
    }
  };
  return (
    <div id="js_profile_from" className="info-model setting-item">
      <Form onSubmit={handleSubmit(onSubmit)} className="info-model-left">
        <div
          className="caption-text border-blue"
          translate="label_setting_data"
        >
          Personal Information
        </div>
        <div className="wrap">
          <div className="form-group" id="WITHDRAWER_NAME">
            <label className="form-label colon" translate="label_payee_name">
              First Name
            </label>
            <div className="input-case fr payeeName-input">
              <input
                className="input-control fr"
                type="text"
                {...register("firstName")}
                placeholder="First name"
              />
            </div>
          </div>{" "}
          <div className="form-group" id="WITHDRAWER_NAME">
            <label className="form-label colon" translate="label_payee_name">
              Last Name
            </label>
            <div className="input-case fr payeeName-input">
              <input
                className="input-control fr"
                type="text"
                {...register("lastName")}
                placeholder="Last name"
              />
            </div>
          </div>{" "}
          <div className="form-group" id="EMAIL">
            <label className="form-label colon" translate="label_email">
              Email
            </label>
            <div
              className={`input-case fr ${
                !isEmpty(errors.email) ? "input-case-error" : ""
              }`}
            >
              <input
                className="input-control "
                type="email"
                {...register("email", {
                  required: "Please enter email",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address.",
                  },
                })}
                placeholder="Email"
              />{" "}
              {errors.email && errors.email.message && (
                <div class="error-tips">{errors.email.message}</div>
              )}
            </div>
          </div>
        </div>
        <div className="setting-item-footer">
          <button
            type="submit"
            className="button btn-submit"
            translate="button_submit"
          >
            Submit
          </button>
        </div>
      </Form>
    </div>
  );
};

export default ProfileComp;
